// Single source of truth for product pricing.
//
// Returns the LINE TOTAL (price for the whole `quantity`) for a product,
// applying any special bundle deals first, then falling back to the
// discounted unit price (or the regular price when there is no discount).
//
// All inputs are coerced to numbers so it behaves correctly even though the
// product data stores prices as `.toFixed(2)` strings.
export const calculateFinalPrice = (
  name,
  quantity,
  basePrice,
  discountPrice,
) => {
  const qty = Number(quantity) || 1;
  const base = Number(basePrice) || 0;
  const discount =
    discountPrice === undefined ||
    discountPrice === null ||
    discountPrice === ""
      ? null
      : Number(discountPrice);

  // Effective per-unit price when no bundle deal applies.
  const unitPrice =
    discount != null && !Number.isNaN(discount) ? discount : base;

  // --- Special bundle deals (these are full line totals, not per unit) ---
  if (name === "Kremi për akne" && qty === 2) return 29.9;

  if (
    name === "Çaji 21 Ditë dobësohu" ||
    name === "Seti 21 Ditë me flokë" ||
    name === "Produkti per shtim peshe"
  ) {
    const priceMap = {
      1: 29.9,
      2: 49.9,
      3: 74.9,
      4: 99.9,
      5: 109.9,
      6: 129.9,
      7: 149.9,
      8: 169.9,
      9: 189.9,
      10: 109.9,
    };
    if (priceMap[qty] != null) return priceMap[qty];
    return unitPrice * qty;
  }

  // --- Default: discounted unit price × quantity ---
  return unitPrice * qty;
};
